<bp-youtube-player [src]="data.src" [loop]="data.loop" [autoplay]="true">
	<ng-container *ngIf="data.customThumbnailTpl as customThumbnailTpl">
		<ng-container *bpCustomThumbnail [ngTemplateOutlet]="customThumbnailTpl"></ng-container>
	</ng-container>
</bp-youtube-player>
